// extracted by mini-css-extract-plugin
export var gray = "SocialIcon-module--gray--6300e";
export var hexagonBG = "SocialIcon-module--hexagonBG--0e704";
export var showTrim = "SocialIcon-module--showTrim--eff22";
export var socialMedia__trim = "SocialIcon-module--socialMedia__trim--8307b";
export var social__icon = "SocialIcon-module--social__icon--63679";
export var white = "SocialIcon-module--white--6f5b9";